<template>
  <div :class="dropDownClasses">
    <div
      class="btn-flex subheading font-weight-bold pointer"
      style="height: 47px;"
      @click="openDropdown"
      >
      <slot name="title" />
    </div>
    <div :class="dropDownContentClasses">
      <div
        v-for="(item, name) in items"
        :key="`drop-down-item-${name}`"
        class="d-flex justify-center align-center btn"
        style="height: 47px;">
        <a
          class="d-block text-sm-center font-weight-medium"
          @click.prevent="$emit('menu-click', name)"
          >
          {{ item.title }}
        </a>
      </div>
    </div>
  </div>
</template>

<script type="js">
export default {
  props: {
    items: {
      type: Object, default: () => ({})
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  name: "DropDown",
  computed: {
    dropDownClasses() {
      const { isOpen } = this;
      return {
        "dropdown-menu": true,
        "btn-primary": true,
        "button": true,
        "rounded": true,
        "rounded-b-0": isOpen
      };
    },
    dropDownContentClasses() {
      const { isOpen } = this;
      return {
        "d-none": !isOpen,
        "dropdown-content": true,
        "rounded": true,
        "rounded-t-0": true
      };
    }
  },
  methods: {
    openDropdown() {
      this.isOpen = !this.isOpen;
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.dropdown-menu {
  position: relative;
  background-color: #f1e41e;
  .v-btn { margin: 0 !important; }
}

.dropdown-content {
  position: absolute;
  margin-top: -2px;
  box-shadow: none !important;
  background-color: #f1e41e;
  width: 100%;
  z-index: 10;

  .btn { border-top: 1px solid rgba(151,151,151,0.36); }

  a { text-decoration: none; }
}
</style>



// WEBPACK FOOTER //
// ./src/components/DropDown.vue